import { AppRouter } from './router';
import { ThemeProvider } from '@shared/configs';
import { AuthProvider } from './providers/AuthProvider';
import { ParamProvider } from './providers/ParamProvider';

//Entry Point of Application
//App Router
//Internal Providers
const App = () => {
  return (
    <>
      <ThemeProvider>
        <ParamProvider>
          <AuthProvider>
            <AppRouter />
          </AuthProvider>
        </ParamProvider>
      </ThemeProvider>
    </>
  );
};

export default App;
